import {
  addDatetime,
  addStringNoLocale,
  addUrl,
  createThing,
  Thing,
  ThingLocal,
} from '@inrupt/solid-client'

export class ThingFactory {
  private thing: ThingLocal

  constructor() {
    this.thing = createThing()
  }

  addUrl(property: string, value: Thing | string): this {
    this.thing = addUrl(this.thing, property, value)
    return this
  }

  addDatetime(property: string, value: Date) {
    this.thing = addDatetime(this.thing, property, value)
    return this
  }

  addStringNoLocale(property: string, value: string) {
    this.thing = addStringNoLocale(this.thing, property, value)
    return this
  }

  build(): ThingLocal {
    return this.thing
  }
}
